export default "__VITE_ASSET__CJCHuw0Q__"